import React, { Component } from 'react';
import './A1.css';
import Dt3 from '../../../assets/texturas/gif-dimen1.gif';
class A1 extends Component{
    render(){
        return(    
        <div className="campoA1" style={{
            backgroundImage: 'url(' + require('../../../assets/fundos/Dt9.jpg') + ')'}}>{this.props.children}
        </div>
        )
    }

}

export default A1;